import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await fetch('/api/auth/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Erreur lors de l’envoi du mail.');
            }

            setSent(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-background-light dark:bg-background-dark min-h-screen flex flex-col font-display transition-colors duration-300">
            <div className="relative flex min-h-screen w-full flex-col items-center justify-center bg-gradient-mesh px-4">
                <div className="w-full max-w-[440px] flex flex-col items-center">
                    <div className="size-24 bg-white dark:bg-slate-900 rounded-3xl flex items-center justify-center border border-slate-200 dark:border-slate-800 shadow-xl shadow-primary/5 p-4 mb-4">
                        <img src="/Stockizio.png" alt="Stockizio Logo" className="w-full h-full object-contain" />
                    </div>
                    <h1 className="text-slate-900 dark:text-slate-100 text-4xl font-black tracking-tighter mt-6">
                        Stock<span className="text-primary">izio</span>
                    </h1>
                    <p className="text-slate-500 dark:text-slate-400 text-sm font-medium uppercase tracking-widest mt-1 opacity-80">Réinitialisation du mot de passe</p>
                    <div className="w-full bg-white dark:bg-slate-900/80 backdrop-blur-xl p-8 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-800">
                        <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-6 text-center">Mot de passe oublié ?</h2>

                        {sent ? (
                            <div className="text-center">
                                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 dark:bg-green-900/30 mb-4">
                                    <span className="material-symbols-outlined text-green-600 dark:text-green-400">check_circle</span>
                                </div>
                                <p className="text-slate-600 dark:text-slate-300 mb-6">
                                    Si cette adresse correspond à un compte actif, vous allez recevoir un e-mail contenant un lien pour réinitialiser votre mot de passe.
                                </p>
                            </div>
                        ) : (
                            <>
                                <p className="text-slate-600 dark:text-slate-400 text-sm mb-6 text-center">
                                    Saisissez l'adresse e-mail associée à votre compte et nous vous enverrons un lien pour le réinitialiser.
                                </p>

                                {error && <div className="mb-4 text-[#ec5b13] text-sm font-semibold text-center">{error}</div>}

                                <form className="space-y-6" onSubmit={handleSubmit}>
                                    <div className="flex flex-col gap-2">
                                        <label className="text-slate-700 dark:text-slate-300 text-sm font-medium">Adresse e-mail</label>
                                        <div className="relative group">
                                            <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-primary transition-colors">email</span>
                                            <input
                                                className="w-full pl-12 pr-4 h-14 bg-slate-50 dark:bg-[#261b16] border border-slate-200 dark:border-primary/20 rounded-xl text-slate-900 dark:text-slate-100 focus:ring-2 focus:ring-primary focus:border-transparent transition-all outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600"
                                                placeholder="votre@email.com"
                                                type="email"
                                                value={email}
                                                onChange={e => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <button
                                        className="w-full h-14 bg-primary hover:bg-orange-600 text-white font-bold rounded-xl transition-all shadow-lg shadow-primary/30 active:scale-[0.98] outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary dark:focus:ring-offset-slate-900"
                                        disabled={loading}
                                        type="submit"
                                    >
                                        {loading ? "Envoi en cours..." : "Envoyer le lien"}
                                    </button>
                                </form>
                            </>
                        )}

                        <div className="mt-8 pt-6 border-t border-slate-100 dark:border-primary/10 text-center">
                            <Link to="/login" className="text-primary font-semibold hover:underline flex items-center justify-center gap-2">
                                <span className="material-symbols-outlined text-sm">arrow_back</span>
                                Retour à la connexion
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
